import { render, staticRenderFns } from "./AddRemoveTags.vue?vue&type=template&id=6c1e4e20&scoped=true"
import script from "./AddRemoveTags.vue?vue&type=script&lang=js"
export * from "./AddRemoveTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1e4e20",
  null
  
)

export default component.exports